/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Dropdown } from "@nordcloud/gnui";
import { InlineEditForm } from "~/components/InlineEdit/InlineEditForm";
import { envStatusOptions } from "~/constants";
import { Environment } from "~/models";
import { displayEnvStatus } from "~/tools";
import { EnvStatusARInfo } from "./EnvStatusARInfo";

type Props = {
  item: Environment;
  onSubmit: (values: Environment) => Promise<void>;
  canEdit: boolean;
};

function InlineDropdownEnvStatus({ item, onSubmit, canEdit }: Props) {
  const [value, setValue] = React.useState(item.status);

  React.useEffect(() => {
    item?.status && setValue(item.status);
  }, [item]);

  return (
    <InlineEditForm
      onSubmit={async () => onSubmit({ ...item, status: value })}
      display={displayEnvStatus(item.status)}
      append={
        item?.environmentStatus?.log?.modified?.author === "system" && (
          <EnvStatusARInfo environmentStatus={item.environmentStatus} />
        )
      }
      canEdit={canEdit}
    >
      <Dropdown
        name="Status"
        options={envStatusOptions}
        value={value}
        onChange={(c: string) => setValue(c)}
        minNumOfOptionsToShowSearchBox={6}
        css={{ width: "15rem" }}
      />
    </InlineEditForm>
  );
}

export { InlineDropdownEnvStatus };
